import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { Invoice } from './legalEntityPracticeV3Invoices.state.model';
const API_URL = environment.legalEntityV3QueryApi;
const PROJECTION_QUERY_API = environment.projectionQueryApi;

@Injectable({
  providedIn: 'root'
})
export class InvoiceQueryService {
  constructor(private httpClient: HttpClient) {}

  public getLegalEntityInvoiceReport(
    invoiceId: string,
    billNumber: string,
    memberId: string
  ): Observable<any> {
    const endpoint = `${API_URL}/AccountingBatchBillReport/${memberId}/LegalEntity/${invoiceId}/GetInvoiceReportByMember/${billNumber}`;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.httpClient.get(endpoint, {
      headers: headers,
      responseType: 'blob' as 'json'
    });
  }
  
  getInvoices(legalEntityNumber: string, memberId: string): Observable<Invoice[]> {
    return this.httpClient.get<Invoice[]>(
      `${API_URL}/AccountingBatch/${memberId}/LegalEntity/${legalEntityNumber}/GetInvoicesByMember`
    );
  }

  getMemberIdByPermitNumber(permitNumber: string): Observable<string> {
    const URL = `${PROJECTION_QUERY_API}/fullMembers?$select=Id&?$filter=PermitNumber eq ${permitNumber}`;
    return this.httpClient.get<any>(URL).pipe(
      map(res => res['value'][0].Id)
    );
  }
}
